import React from 'react';
import { motion } from 'framer-motion';

const PasswordStrengthMeter = ({ password }) => {
  const getStrength = (pass) => {
    let score = 0;
    if (!pass) return 0;
    if (pass.length >= 10) score += 1;
    if (/[a-z]/.test(pass) && /[A-Z]/.test(pass)) score += 1;
    if (/\d/.test(pass)) score += 1;
    if (/[^A-Za-z0-9]/.test(pass)) score += 1;
    return score;
  };

  const strength = getStrength(password);
  
  const config = [
    { label: 'Too Weak', color: 'bg-gray-200', width: '25%' },
    { label: 'Weak', color: 'bg-red-500', width: '25%' },
    { label: 'Medium', color: 'bg-amber-500', width: '50%' },
    { label: 'Strong', color: 'bg-green-500', width: '75%' },
    { label: 'Very Strong', color: 'bg-emerald-600', width: '100%' }
  ];

  const current = config[strength];

  return (
    <div className="mt-3">
      <div className="flex justify-between items-center mb-1.5">
        <span className="text-[10px] font-black uppercase tracking-widest text-gray-400">
          Security Level
        </span>
        <span className={`text-[10px] font-black uppercase tracking-widest ${strength > 0 ? 'text-gray-900' : 'text-gray-300'}`}>
          {current.label}
        </span>
      </div>
      <div className="h-1.5 w-full bg-gray-100 rounded-full overflow-hidden flex gap-0.5">
        {[1, 2, 3, 4].map((step) => (
          <motion.div
            key={step}
            initial={{ opacity: 0 }}
            animate={{ 
              opacity: 1,
              backgroundColor: step <= strength ? (
                strength <= 1 ? '#ef4444' : 
                strength === 2 ? '#f59e0b' : 
                '#10b981'
              ) : '#f3f4f6'
            }}
            className="h-full flex-1 transition-colors duration-500"
          />
        ))}
      </div>
      <p className="text-[10px] text-gray-400 mt-2 font-medium">
        Use 10+ characters with mixed cases, numbers, and symbols.
      </p>
    </div>
  );
};

export default PasswordStrengthMeter;